import { connect } from 'react-redux';
import { Layout } from 'react-admin';

const darkTheme = {
  palette: {
    type: 'dark' // Switching the dark mode on is a single property value change.
  }
};

const lightTheme = {
  typography: {
    fontFamily: 'Tajawal'
  },
  palette: {
    secondary: {
      main: '#d81b60',
      light: '#ff5c8d',
      dark: '#a00037',
      contrastText: '#ffffff'
    },
    primary: {
      main: '#d81b60'
    }
  }
};

export default connect(
  state => ({
    theme: state.theme === 'dark' ? darkTheme : lightTheme
  }),
  {}
)(Layout);



// WEBPACK FOOTER //
// ./src/Layout.js